/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PlatformAccess } from './PlatformAccess';
import {
    PlatformAccessFromJSON,
    PlatformAccessFromJSONTyped,
    PlatformAccessToJSON,
} from './PlatformAccess';

/**
 * 
 * @export
 * @interface PartialGroup
 */
export interface PartialGroup {
    /**
     * 
     * @type {number}
     * @memberof PartialGroup
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialGroup
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialGroup
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialGroup
     */
    totalAgents?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialGroup
     */
    editorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialGroup
     */
    applicationType?: string;
    /**
     * 
     * @type {PlatformAccess}
     * @memberof PartialGroup
     */
    platformAccess?: PlatformAccess;
    /**
     * 
     * @type {string}
     * @memberof PartialGroup
     */
    welcomeScreen?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialGroup
     */
    holdReservation?: string;
}

/**
 * Check if a given object implements the PartialGroup interface.
 */
export function instanceOfPartialGroup(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartialGroupFromJSON(json: any): PartialGroup {
    return PartialGroupFromJSONTyped(json, false);
}

export function PartialGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartialGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'totalAgents': !exists(json, 'totalAgents') ? undefined : json['totalAgents'],
        'editorName': !exists(json, 'editorName') ? undefined : json['editorName'],
        'applicationType': !exists(json, 'applicationType') ? undefined : json['applicationType'],
        'platformAccess': !exists(json, 'platformAccess') ? undefined : PlatformAccessFromJSON(json['platformAccess']),
        'welcomeScreen': !exists(json, 'welcomeScreen') ? undefined : json['welcomeScreen'],
        'holdReservation': !exists(json, 'holdReservation') ? undefined : json['holdReservation'],
    };
}

export function PartialGroupToJSON(value?: PartialGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'totalAgents': value.totalAgents,
        'editorName': value.editorName,
        'applicationType': value.applicationType,
        'platformAccess': PlatformAccessToJSON(value.platformAccess),
        'welcomeScreen': value.welcomeScreen,
        'holdReservation': value.holdReservation,
    };
}

